import React, { useState } from 'react';
import { useAppSelector } from '../../hooks/store';
import { useTranslation } from 'react-i18next';
import RequestItem from './RequestItem';
import './RequestList.css';
import DropDownList from '../common/DropDownList';

const TYPES_RU = ['Все', 'В процессе', 'Подтвержденные', 'Отклоненные', 'Отмененные'];
const TYPES_EN = ['All', 'Negotiation', 'Approved', 'Rejected', 'Cancelled'];
const FILTER = ['', 'negotiation', 'approved', 'rejected', 'cancelled'];

const RequestList = () => {
	const { i18n } = useTranslation();
	const types = i18n.language === 'en' ? TYPES_EN : TYPES_RU;
    const requests = useAppSelector(store => store.requests);
    const [ status, setStatus ] = useState(types[0]);
    const [ filter, setFilter ] = useState(FILTER[0]);

    const onChangeStatus = (status: string, index: number) => {
        setStatus(status);
        setFilter(FILTER[index]);
    };

	return (
        <div className='RequestList'>
            <DropDownList list={types} current={status} onChange={onChangeStatus}/>
            <ul>
                {requests.map(req => <RequestItem key={req.id} request={req} filter={filter}/>)}
            </ul>
        </div>
	);
};

export default RequestList;
